import { isFieldTypeSupported } from '@atlassian/ui-modifications-core/controllers';
import { getNormalizedType } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-normalized-field-type/index.tsx';
import { GIC_VIEW_TYPE } from '../../../../common/constants/index.tsx';
import type { FieldConfig } from './types.tsx';

export const getSupportedFieldsCount = (fields: Record<string, FieldConfig>): number => {
	if (!fields) {
		return 0;
	}
	return Object.values<FieldConfig>(fields).filter(({ fieldType, gqlType }: FieldConfig) => {
		const normalizedType = getNormalizedType(fieldType, gqlType);
		return isFieldTypeSupported(GIC_VIEW_TYPE, normalizedType);
	}).length;
};
